import { AxiosResponse } from 'axios'
import { Message } from 'element-ui'
import defaultRules from './defaults'
import {
  IDDErrorHandler,
  IDDErrorHandlerError,
  IDDErrorHandlerErrorList,
} from './dd-error-handler.types'
import VueRouter from 'vue-router'
import { Store } from 'vuex'
import strings from '@/plugins/dd-strings/dd-strings.strings.ts'

export default class DDErrorHandler implements IDDErrorHandler {
  private router: VueRouter
  private store: Store<any>

  constructor(router: VueRouter, store: Store<any>) {
    this.router = router
    this.store = store
  }

  public emit(
    error: AxiosResponse,
    exposeDataErrorsAsNotifications: boolean = false,
  ) {
    if (!error || !error.status) {
      if (process.env.NODE_ENV === 'development') {
        throw new Error('No error provided for error....that is an error!')
      }
      return false
    }

    let rules: IDDErrorHandlerErrorList = {}

    if (exposeDataErrorsAsNotifications) {
      rules = {
        503: {
          notification: {
            message: error.data
              ? error.data.message
              : strings.GENERIC_ERROR_MESSAGE,
          },
        },
        500: {
          notification: {
            message: error.data
              ? error.data.message
              : strings.GENERIC_ERROR_MESSAGE,
          },
        },
        404: {
          notification: {
            message: error.data
              ? error.data.message
              : strings.GENERIC_ERROR_MESSAGE,
          },
        },
        403: {
          notification: {
            message: error.data
              ? error.data.message
              : strings.GENERIC_ERROR_MESSAGE,
          },
        },
        429: {
          notification: {
            message: error.data
              ? error.data.message
              : strings.GENERIC_ERROR_MESSAGE,
          },
        },
      }
    }

    if (rules[error.status]) {
      this.executeRule(error, rules[error.status])
    } else {
      this.executeDefaultRule(error)
    }
  }

  private executeDefaultRule(error: AxiosResponse) {
    const defaultRule = defaultRules[error.status]
    if (defaultRule) {
      this.executeRule(error, defaultRule)
    }
  }

  private executeRule(error: AxiosResponse, rule: IDDErrorHandlerError) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[DDErrorHandler]: Error:', error)
      console.error('[DDErrorHandler]: Rule to execute: ', rule)
    }

    if (rule.hasOwnProperty('handler')) {
      rule.handler(this.router, this.store, error, {})
    }

    if (rule.hasOwnProperty('notification')) {
      Message({
        type: rule.notification.type || 'error',
        center: true,
        message:
          rule.notification.message ||
          error.data.message ||
          strings.GENERIC_ERROR_MESSAGE,
      })
    }

    if (rule.hasOwnProperty('redirect')) {
      this.router.push(rule.redirect)
    }
  }
}
